import cx from "classnames";

import Container from "./Container";

import styles from "../../styles/Subheader.module.less";

type SubheaderBaseProps = { children: React.ReactNode; className?: string };

const SubheaderBase = ({ children, className }: SubheaderBaseProps) => {
  return (
    <div className={cx(className)}>
      <Container>{children}</Container>
    </div>
  );
};

type SubheaderTitleProps = { children: React.ReactNode };

const SubheaderTitle = ({ children }: SubheaderTitleProps) => {
  return <h1 className={styles.title}>{children}</h1>;
};

type SubheaderDescriptionProps = { children: React.ReactNode };

const SubheaderDescription = ({ children }: SubheaderDescriptionProps) => {
  return <div className={styles.description}>{children}</div>;
};

type SubheaderClassNames = {
  container?: string;
  base?: string;
  actions?: string;
};

type SubheaderProps = {
  title: string;
  description?: React.ReactNode;
  renderStatus?: () => React.ReactNode;
  renderActions?: () => React.ReactNode;
  classNames?: SubheaderClassNames;
  shouldCenterText?: boolean;
};

const noop = () => null;

const Subheader = ({
  title,
  description,
  renderStatus = noop,
  renderActions = noop,
  shouldCenterText = false,
  classNames = {},
}: SubheaderProps) => {
  const status = renderStatus();
  const actions = renderActions();

  return (
    <div className={cx(styles.container, classNames.container)}>
      <SubheaderBase className={classNames.base}>
        <div className={styles.content}>
          <div className={cx(styles.header, shouldCenterText && styles.center)}>
            <SubheaderTitle>
              {title} {status && <div className={styles.status}>{status}</div>}
            </SubheaderTitle>
            {description && <SubheaderDescription>{description}</SubheaderDescription>}
          </div>
          {actions && <div className={cx(styles.actions, classNames.actions)}>{actions}</div>}
        </div>
      </SubheaderBase>
    </div>
  );
};

export default Object.assign(Subheader, {
  Base: SubheaderBase,
  Title: SubheaderTitle,
  Description: SubheaderDescription,
});
